import {request} from '@/sujs/http.js'
export function userReg(data){
	return request({
		url:'/pc/user/reg',
		method:"POST",
		data:data
	})
}
